(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.colstoryReady === '1') return;
      var stage = root.querySelector('[data-stage]');
      if (!stage) return;
      var slides = stage.querySelectorAll('[data-slide]');
      if (slides.length === 0) {
        root.dataset.colstoryReady = '1';
        return;
      }
      root.dataset.colstoryReady = '1';

      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var autoplay = parseInt(root.dataset.autoplay, 10) || 0;
      var index = 0;
      var timer = null;
      var programmatic = false;
      var programmaticTimer = null;

      function isMobile() {
        return window.matchMedia('(max-width: 989px)').matches;
      }

      function setActive(i) {
        index = i;
        for (var j = 0; j < slides.length; j++) {
          slides[j].setAttribute('aria-hidden', j === index ? 'false' : 'true');
        }
      }

      function scrollToIndex(i, smooth) {
        var slide = slides[i];
        if (!slide) return;
        var stageRect = stage.getBoundingClientRect();
        var slideRect = slide.getBoundingClientRect();
        var pos = slideRect.left - stageRect.left + stage.scrollLeft;
        var target;
        if (isMobile()) {
          target = pos - window.innerWidth * 0.10;
        } else {
          target = pos - (stage.clientWidth - slide.offsetWidth) / 2;
        }
        target = Math.max(0, target);
        programmatic = true;
        clearTimeout(programmaticTimer);
        programmaticTimer = setTimeout(function () { programmatic = false; }, 800);
        try {
          stage.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
        } catch (e) {
          stage.scrollLeft = target;
        }
      }

      function go(i) {
        var n = (i + slides.length) % slides.length;
        setActive(n);
        scrollToIndex(n, true);
      }

      function start() {
        stop();
        if (autoplay > 0 && slides.length > 1) {
          timer = setInterval(function () { go(index + 1); }, autoplay * 1000);
        }
      }

      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
      if (next) next.addEventListener('click', function () { go(index + 1); start(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      var scrollDebounce;
      stage.addEventListener('scroll', function () {
        if (programmatic) return;
        clearTimeout(scrollDebounce);
        scrollDebounce = setTimeout(function () {
          var stageRect = stage.getBoundingClientRect();
          var stageCenter = stageRect.left + stage.clientWidth / 2;
          var nearest = 0;
          var nearestDist = Infinity;
          for (var i = 0; i < slides.length; i++) {
            var rect = slides[i].getBoundingClientRect();
            var c = rect.left + rect.width / 2;
            var d = Math.abs(c - stageCenter);
            if (d < nearestDist) {
              nearestDist = d;
              nearest = i;
            }
          }
          if (nearest !== index) setActive(nearest);
        }, 90);
      });

      stage.addEventListener('touchstart', stop, { passive: true });

      setActive(0);
      start();
    }

    function initAll() {
      document.querySelectorAll('.colstory').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.colstory');
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-as-seen-on"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function getStep(track) {
      var first = track.querySelector('.editorial-as-seen-on__item');
      if (!first) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateArrows(section) {
      var track = section.querySelector('[data-eas-track]');
      if (!track) return;
      var prev = section.querySelector('[data-eas-prev]');
      var next = section.querySelector('[data-eas-next]');
      var max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-eas-prev], [data-eas-next]');
      if (!btn) return;
      var section = btn.closest('.editorial-as-seen-on');
      if (!section) return;
      var track = section.querySelector('[data-eas-track]');
      if (!track) return;
      var dir = btn.hasAttribute('data-eas-prev') ? -1 : 1;
      var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      track.scrollBy({ left: dir * getStep(track), behavior: behavior });
    });

    function init() {
      document.querySelectorAll('.editorial-as-seen-on').forEach(function (section) {
        var track = section.querySelector('[data-eas-track]');
        if (!track || track.dataset.easInit) return;
        track.dataset.easInit = '1';
        track.addEventListener('scroll', function () {
          updateArrows(section);
        }, { passive: true });
        window.addEventListener('resize', function () {
          updateArrows(section);
        });
        updateArrows(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naomi-category-bar"] && !Shopify.designMode) return;
  try {
    
  // Toggles the edge-fade masks as the row scrolls; the fade only shows
  // on a side where more categories are actually hidden.
  class NaomiScrollHint extends HTMLElement {
    // Overflow below this many pixels is treated as fully visible, so a
    // fade never ghosts a label to hide a sliver.
    static overflowThreshold = 24;

    connectedCallback() {
      this.update = this.update.bind(this);
      this.addEventListener('scroll', this.update, { passive: true });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this);
      // The scroller's own width is fixed, so also watch the list, whose
      // width shifts when web fonts land and would leave the fades stale.
      const list = this.querySelector('.naomi-catbar__list');
      if (list) this.resizeObserver.observe(list);
      document.fonts?.ready.then(() => {
        if (this.isConnected) {
          this.centerCurrent();
          this.update();
        }
      });
      this.centerCurrent();
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('scroll', this.update);
      this.resizeObserver?.disconnect();
    }

    // Park the current category in view on arrival, instantly (no smooth
    // scroll, so no reduced-motion concern), without touching the page's
    // vertical scroll position.
    centerCurrent() {
      const current = this.querySelector('.naomi-catbar__link--current');
      if (!current) return;
      const target = current.offsetLeft + current.offsetWidth / 2 - this.clientWidth / 2;
      this.scrollLeft = Math.max(0, Math.min(target, this.scrollWidth - this.clientWidth));
    }

    update() {
      const max = this.scrollWidth - this.clientWidth;
      const overflowing = max >= NaomiScrollHint.overflowThreshold;
      this.toggleAttribute('data-overflow-start', overflowing && this.scrollLeft > 1);
      this.toggleAttribute('data-overflow-end', overflowing && this.scrollLeft < max - 1);
    }
  }

  if (!customElements.get('naomi-scroll-hint')) {
    customElements.define('naomi-scroll-hint', NaomiScrollHint);
  }

  } catch(e) { console.error(e); }
})();
})();
